import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { HIDDEN } from 'constants/stylePresetType'
import { getCustomStylesById } from 'utils/appUtils'
import { getCustomStyleClassName } from 'controllers/logic'

class HiddenOverlay extends Component {

  constructor (props) {
    super(props)
    this.state = {
      rect: this.calcRect()
    }
    this.timerId = setInterval(this.updateRect, 50)
  }

  getClassName = (className) => {
    const { app, field } = this.props
    return getCustomStyleClassName(app, field, className)
  }

  processHiddenElement (elt) {
    const { field, app } = this.props

    if (field && field.stylePresets) {
      const hiddenPreset = field.stylePresets.find(preset => (preset.presetType === HIDDEN))

      if (hiddenPreset) {
        const className = this.getClassName(hiddenPreset.className)
        const customStyles = getCustomStylesById(app, className)
        if (customStyles[HIDDEN]) {
          const hiddenSwitchValue = customStyles[HIDDEN].value
          if (hiddenSwitchValue === true) {
            if (className.includes('co_slide__tip')) {
              elt.style.display = 'flex'
            } else {
              elt.style.display = 'block'
            }
            elt.style.opacity = '0.3'
          }
        }
      }
    }
  }

  componentWillUnmount () {
    clearInterval(this.timerId)
    this.updateRect = () => null
  }

  calcRect = () => {
    const { field } = this.props
    let rect
    if ('overlayKey' in field) {
      const key = field.overlayKey
      const elt = document.getElementById(key)
      if (elt && 'getBoundingClientRect' in elt) {
        rect = elt.getBoundingClientRect()
        this.processHiddenElement(elt)
      }
    }
    return rect
  }

  updateRect = () => {
    const newRect = this.calcRect()
    const { rect } = this.state
    if (!rect) {
      this.setState({ rect: newRect })
      return
    }
    if (newRect) {
      if (rect.width !== newRect.width || rect.height !== newRect.height || rect.top !== newRect.top || rect.left !== newRect.left) {
        this.setState({ rect: newRect })
      }
    }
  }

  onOverlayHover = (e) => {
    const { field, fieldNum, onOverlayHover } = this.props
    onOverlayHover(field, fieldNum)
  }

  render () {
    const { field, isEditingText } = this.props
    const { rect } = this.state
    if (!field) return null
    const overlayStyle = field.overlayStyle
    if (overlayStyle && rect) {
      const style = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height,
        position: 'fixed'
      }
      if (isEditingText) {
        style.zIndex = -1
      }
      return (
        <div
          style={style}
          onMouseEnter={this.onOverlayHover}
        />
      )
    } else {
      return null
    }
  }
}

HiddenOverlay.propTypes = {
  app: PropTypes.object,
  field: PropTypes.object,
  onOverlayHover: PropTypes.func,
  fieldNum: PropTypes.number,
  isEditingText: PropTypes.bool
}

export default connect()(HiddenOverlay)



// WEBPACK FOOTER //
// ./src/components/editor/HiddenOverlay.js